import { addDays, differenceInCalendarDays, parseISO, getDay } from "date-fns";
import { iso } from "@/lib/format";

export function cycleStats(periods, prefs) {
  const starts = periods.map((p) => p.date).sort();
  const gaps = [];
  for (let i = 1; i < starts.length; i++) {
    const g = differenceInCalendarDays(parseISO(starts[i]), parseISO(starts[i - 1]));
    if (g >= 20 && g <= 45) gaps.push(g);
  }
  const lens = periods.filter((p) => p.end).map((p) => differenceInCalendarDays(parseISO(p.end), parseISO(p.date)) + 1).filter((l) => l > 0 && l < 11);
  const avg = (a, d) => (a.length ? Math.round(a.slice(-6).reduce((x, y) => x + y, 0) / Math.min(a.length, 6)) : d);
  return { cycle: avg(gaps, prefs?.cycle_length || 28), length: avg(lens, prefs?.period_length || 5), lastStart: starts[starts.length - 1] };
}

export function predictions(periods, prefs, count = 4) {
  const { cycle, length, lastStart } = cycleStats(periods, prefs);
  if (!lastStart) return [];
  const out = [];
  let start = addDays(parseISO(lastStart), cycle);
  const today = new Date();
  while (differenceInCalendarDays(start, today) < -length) start = addDays(start, cycle);
  for (let i = 0; i < count; i++) {
    out.push({ start: iso(start), end: iso(addDays(start, length - 1)), ovulation: iso(addDays(start, -14)) });
    start = addDays(start, cycle);
  }
  return out;
}

export function daySets(periods, prefs) {
  const actual = new Set();
  const { length } = cycleStats(periods, prefs);
  periods.forEach((p) => {
    const end = p.end ? parseISO(p.end) : addDays(parseISO(p.date), length - 1);
    for (let d = parseISO(p.date); d <= end; d = addDays(d, 1)) actual.add(iso(d));
  });
  const predicted = new Set();
  const fertile = new Set();
  predictions(periods, prefs, 6).forEach((p) => {
    for (let d = parseISO(p.start); d <= parseISO(p.end); d = addDays(d, 1)) if (!actual.has(iso(d))) predicted.add(iso(d));
    for (let k = -3; k <= 1; k++) fertile.add(iso(addDays(parseISO(p.ovulation), k)));
  });
  return { actual, predicted, fertile };
}

export function isOffDay(dateStr, dayMap) {
  return dayMap[dateStr]?.status === "off";
}

export const isWeeklyPiket = (dateStr, prefs) => (prefs?.piket_weekly ?? [0]).includes(getDay(parseISO(dateStr)));

export function isPiketDay(dateStr, dayMap, prefs) {
  const s = dayMap[dateStr]?.status || "default";
  return s === "piket" || (s === "default" && isWeeklyPiket(dateStr, prefs));
}
